export const keadaanUmumOptions = [
  { value: "baik", text: "Baik" },
  { value: "cukup", text: "Cukup" },
  { value: "lemah", text: "Lemah" },
  { value: "sakit_ringan", text: "Sakit Ringan" },
  { value: "sakit_sedang", text: "Sakit Sedang" },
  { value: "sakit_berat", text: "Sakit Berat" }
];

export const kesadaranOptions = [
  { value: "compos_mentis", text: "Compos Mentis" },
  { value: "apatis", text: "Apatis" },
  { value: "somnolen", text: "Somnolen" },
  { value: "sopor", text: "Sopor" },
  { value: "coma", text: "Coma" }
];

export const kbJenisOptions = [
  "IUD",
  "Implant",
  "Suntik 3 bulan",
  "Suntik 1 bulan",
  "Pil kombinasi",
  "Pil progestin",
  "MAL",
  "Kondom",
  "Tubektomi",
  "Vasektomi",
  "Kalender",
  "Lainnya"
];

// Riwayat pemakaian KB — blanko Asesmen Awal Gawat Darurat RSPS.
// Satu isian (metode ATAU "Tidak KB"), disimpan sebagai teks di kolom
// `pemeriksaan_obsgyn.kb_jenis` — menggantikan pasangan lama
// "KB" (kbStatusOptions) + "Jenis KB" (kbJenisOptions) di form IGD.
export const KB_TIDAK_KB = "Tidak KB";

export const kbRiwayatPemakaianOptions = [
  "IUD",
  "Implant",
  "Suntik",
  "Kondom",
  "Pil",
  "MDP",
  "Kalender",
  "MOW",
  KB_TIDAK_KB
];

// Status KB kategorikal (legacy ref_kb) — dipakai di form IGD/Obsgyn.
// ID 0/1/2 dipertahankan untuk kompatibilitas data lama.
export const kbStatusOptions = [
  { id: 0, name: "Tidak KB" },
  { id: 1, name: "Kontap" },
  { id: 2, name: "Mandiri" }
];

export const jenisPartusOptions = [
  "Spontan",
  "Vakum",
  "Forceps",
  "SC",
  "Induksi"
];

export const penolongPartusOptions = [
  "Bidan",
  "Dokter Umum",
  "Dokter SpOG",
  "Dukun",
  "Sendiri"
];

export const konteksOptions = [
  { value: "anc", text: "ANC (Antenatal Care)" },
  { value: "inc", text: "INC (Intranatal Care)" },
  { value: "pnc", text: "PNC (Postnatal Care)" },
  { value: "triase", text: "Triase Kebidanan" },
  { value: "lainnya", text: "Lainnya" }
];

export const statusPernikahanOptions = [
  { value: "belum_menikah", text: "Belum Menikah" },
  { value: "cerai", text: "Cerai" },
  { value: "menikah", text: "Menikah" }
];

export const hisIntensitasOptions = [
  { value: "kuat", text: "Kuat" },
  { value: "sedang", text: "Sedang" },
  { value: "lemah", text: "Lemah" }
];

export const anakJkOptions = [
  { value: "L", text: "Laki-laki" },
  { value: "P", text: "Perempuan" }
];
